import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import ListConstructor from './ListConstructor';
import ConstructorForm from './ConstructorForm';
import { drapcodeIcon } from '../../../../common/custom/icon-library';
import DocsLink from '../../../../common/custom/DocsLink';
import ParentDocCard from '../../../common/ParentDocCard';

export default class ConstructorBuilder extends Component {
  static propTypes = {
    actions: PropTypes.object.isRequired,
    projectId: PropTypes.string.isRequired,
    constructors: PropTypes.array,
    collection: PropTypes.object.isRequired,
    collections: PropTypes.object.isRequired,
  };
  render() {
    const { actions, collection, projectId, constructors, collections, version, deleteFlag, plugins, s3Url } =
      this.props;
    const showConstructorDeleteLoader = collections.deleteConstructorPending;

    return (
      <div className="row mx-auto">
        <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 drapcode">
          <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 drapcode">
            <div className="card">
              <div
                className="card-header card-header-icon"
                data-background-color="drapcode-dark-blue"
              >
                <i className={`wb ${drapcodeIcon('form')}`}></i>
              </div>
              <div className="card-content">
                <h5 className="card-title mb-0 pb-0">
                  Add Constructor{' '}
                  {typeof collection !== 'undefined' && collection
                    ? ' To ' + collection.collectionTitle
                    : ''}
                </h5>

                <p>Sets a default value in a collection field if no input is added by users.</p>
                <ConstructorForm
                  actions={actions}
                  version={version}
                  collection={collection}
                  projectId={projectId}
                  collections={collections}
                  plugins={plugins}
                  s3Url={s3Url}
                />
              </div>
            </div>
          </div>
          <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 drapcode">
            <div className="card">
              <div
                className="card-header card-header-icon"
                data-background-color="drapcode-dark-blue"
              >
                <i className={`wb ${drapcodeIcon('list')}`}></i>
              </div>
              <div className="card-content">
                <h5 className="card-title">Constructors</h5>
                <ListConstructor
                  constructors={constructors}
                  actions={actions}
                  version={version}
                  projectId={projectId}
                  collection={collection}
                  showConstructorDeleteLoader={showConstructorDeleteLoader}
                  deleteFlag={deleteFlag}
                />
              </div>
            </div>
          </div>
        </div>
        <ParentDocCard>
          <h5>
            <b>About Constructors</b>
          </h5>
          <p>
            Allows you to set a value in a collection field if no input is added in the field by the
            users so that no field is left empty in the output.
          </p>
          <br />
          <DocsLink link="https://academy.drapcode.com/docs/app-collection/constructor-in-collection" />
        </ParentDocCard>
      </div>
    );
  }
}
